import { request } from "@/api/server/index";

export default {
  //V036_募集企画登録画面
  RecruitmentPlanEdit: {
    // 初期表示
    indexRecruitmentPlanEdit(params) {
      return request({
        url: "/recruitmentPlanEdit/indexRecruitmentPlanEdit",
        data: params,
        method: "post"
      });
    },
    // 登録
    insertRecruitmentPlanEdit(params) {
      return request({
        url: "/recruitmentPlanEdit/insertRecruitmentPlanEdit",
        data: params,
        method: "post"
      });
    },
    // 募集企画更新
    updateRecruitmentPlanEdit(params) {
      return request({
        url: "/recruitmentPlanEdit/updateRecruitmentPlanEdit",
        data: params,
        method: "post"
      });
    }
  },
  //V037_募集企画一覧画面
  RecruitmentPlanList: {
    // 初期表示
    indexRecruitmentPlanList(params) {
      return request({
        url: "/recruitmentPlanList/indexRecruitmentPlanList",
        data: params,
        method: "post"
      });
    },
    // 検索
    searchRecruitmentPlanList(params) {
      return request({
        url: "/recruitmentPlanList/searchRecruitmentPlanList",
        data: params,
        method: "post"
      });
    }
  },
  //V038_募集企画対象者一覧画面
  RecruitmentPlanTargetList: {
    // 初期表示
    indexRecruitmentPlanTargetList(params) {
      return request({
        url: "/recruitmentPlanTargetList/indexRecruitmentPlanTargetList",
        data: params,
        method: "post"
      });
    },
    // 部署のリストを更新します
    searchDepartmentList(params) {
      return request({
        url: "/recruitmentPlanTargetList/searchDepartmentList",
        data: params,
        method: "post"
      });
    },
    // 検索
    searchRecruitmentPlanTargetList(params) {
      return request({
        url: "/recruitmentPlanTargetList/searchRecruitmentPlanTargetList",
        data: params,
        method: "post"
      });
    },
    // 進捗変更
    progressChange(params) {
      return request({
        url: "/recruitmentPlanTargetList/progressChange",
        data: params,
        method: "post"
      });
    },
    // 区分変更
    classCdChange(params) {
      return request({
        url: "/recruitmentPlanTargetList/classCdChange",
        data: params,
        method: "post"
      });
    },
    // 担当者一括変更
    staffInChargeBusinessChange(params) {
      return request({
        url: "/recruitmentPlanTargetList/staffInChargeBusinessChange",
        data: params,
        method: "post"
      });
    },
    // V038_募集企画対象者一覧画面 CSV出力
    outputCsv(params) {
      return request({
        url: "/recruitmentPlanTargetList/outputCsv",
        data: params,
        method: "post",
        responseType: "blob"
      });
    },
    // V038_顧客条件抽出画面 データ存在チェック
    checkSelectUserId(params) {
      return request({
        url: "/recruitmentTargetExtract/checkSelectUserId",
        data: params,
        method: "post"
      });
    },
  },
  //V039_顧客条件抽出画面
  RecruitmentTargetExtract: {
    // 初期表示
    indexRecruitmentTargetExtract(params) {
      return request({
        url: "/recruitmentTargetExtract/indexRecruitmentTargetExtract",
        data: params,
        method: "post"
      });
    },
    // 主契約保険種類マスタの取得
    searchMainProdList(params) {
      return request({
        url: "/recruitmentTargetExtract/searchMainProdList",
        data: params,
        method: "post"
      });
    },
    // 特約保険種類マスタの取得
    searchSpecialProdList(params) {
      return request({
        url: "/recruitmentTargetExtract/searchSpecialProdList",
        data: params,
        method: "post"
      });
    },
    // 抽出
    searchRecruitmentTargetExtract(params) {
      return request({
        url: "/recruitmentTargetExtract/searchRecruitmentTargetExtract",
        data: params,
        method: "post"
      });
    },
    // 顧客分類一括削除
    deleteCustomerCategoryList(params) {
      return request({
        url: "/recruitmentTargetExtract/deleteCustomerCategoryList",
        data: params,
        method: "post"
      });
    },
    // 顧客分類一括登録
    insertCustomerCategoryList(params) {
      return request({
        url: "/recruitmentTargetExtract/insertCustomerCategoryList",
        data: params,
        method: "post"
      });
    },
    // 営業担当者一括変更
    updateRecruitmentTargetExtractList(params) {
      return request({
        url: "/recruitmentTargetExtract/updateRecruitmentTargetExtractList",
        data: params,
        method: "post"
      });
    },
    // 募集企画対象者一括登録
    insertCampaignCustomerList(params) {
      return request({
        url: "/recruitmentTargetExtract/insertCampaignCustomerList",
        data: params,
        method: "post"
      });
    },
    // 募集企画対象者一覧登録画面 初期表示
    indexCampaignCustomer(params) {
      return request({
        url: "/recruitmentTargetExtract/indexCampaignCustomer",
        data: params,
        method: "post"
      });
    },
    // V039_顧客条件抽出画面 宛名ラベル出力
    outputMailingLabel(params) {
      return request({
        url: "/recruitmentTargetExtract/outputMailingLabel",
        data: params,
        method: "post",
        responseType: "blob"
      });
    },
    // V039_顧客条件抽出画面 CSV出力
    outputCsv(params) {
      return request({
        url: "/recruitmentTargetExtract/outputCsv",
        data: params,
        method: "post",
        responseType: "blob"
      });
    },
    // V039_顧客条件抽出画面 データ存在チェック
    checkSelectUserId(params) {
      return request({
        url: "/recruitmentTargetExtract/checkSelectUserId",
        data: params,
        method: "post"
      });
    }
  },
  //V040_案件一括登録画面
  ProposalBatchCreation: {
    // 初期表示
    indexProposalBatchCreation(params) {
      return request({
        url: "/proposalBatchCreation/indexProposalBatchCreation",
        data: params,
        method: "post"
      });
    },
    // 一括登録
    insertProposalBatchCreation(params) {
      return request({
        url: "/proposalBatchCreation/insertProposalBatchCreation",
        data: params,
        method: "post"
      });
    }
  },
  // V072_システム推奨募集対象担当未割振一覧画面
  PICNotAssignedTarget: {
    // 初期表示
    indexPICNotAssignedTarget(params) {
      return request({
        url: "/pICNotAssignedTarget/indexPICNotAssignedTarget",
        data: params,
        method: "post"
      });
    },
    // 検索
    searchPICNotAssignedTarget(params) {
      return request({
        url: "/pICNotAssignedTarget/searchPICNotAssignedTarget",
        data: params,
        method: "post"
      });
    },
    // 一括割振
    updatePICNotAssignedTargetList(params) {
      return request({
        url: "/pICNotAssignedTarget/updatePICNotAssignedTargetList",
        data: params,
        method: "post"
      });
    }
  }
};
